module.exports = __webpack_public_path__ + "static/media/phone.699aabe9.svg";